// All_Customers.js
import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase/firebase-config";
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { motion, AnimatePresence } from "framer-motion";
import "./AllCustomers.css";

/* -------------------------- Tiny inline SVG icons -------------------------- */
const Icon = {
  Plus: (p) => (
    <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M8 1a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2H9v5a1 1 0 1 1-2 0V9H2a1 1 0 1 1 0-2h5V2a1 1 0 0 1 1-1z" />
    </svg>
  ),
  Pencil: (p) => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-9.5 9.5-3.975.993a.5.5 0 0 1-.606-.606l.993-3.975 9.5-9.5zM11.207 2.5 13.5 4.793 12.5 5.793 10.207 3.5l1-1z" />
    </svg>
  ),
  Trash: (p) => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M5.5 5.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zM8 5.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zM11 6a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
      <path d="M14.5 3a1 1 0 0 1-1 1h-11a1 1 0 1 1 0-2h2.5A1.5 1.5 0 0 1 6.5.5h3A1.5 1.5 0 0 1 11 2h2.5a1 1 0 0 1 1 1zM4.118 4.5h7.764l-.846 9.017A2 2 0 0 1 9.05 15.5H6.95a2 2 0 0 1-1.986-1.983L4.118 4.5z" />
    </svg>
  ),
  Download: (p) => (
    <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M.5 9.9a.5.5 0 0 1 .5.5V13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V10.4a.5.5 0 0 1 1 0V13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V10.4a.5.5 0 0 1 .5-.5z" />
      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 1 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L4.854 7.646a.5.5 0 1 0-.708.708l3.5 3.5z" />
    </svg>
  ),
  Save: (p) => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M2 1a2 2 0 0 0-2 2v10.5A1.5 1.5 0 0 0 1.5 15h13a1.5 1.5 0 0 0 1.5-1.5V4.707a1 1 0 0 0-.293-.707l-2.707-2.707A1 1 0 0 0 12.293 1H2z" />
      <path d="M2 1h9v3H2V1zm3 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
    </svg>
  ),
  X: (p) => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  ),
  XCircle: (p) => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14z" />
      <path d="M5.354 5.354a.5.5 0 1 1 .707-.708L8 6.586l1.939-1.94a.5.5 0 1 1 .707.708L8.707 7.293l1.94 1.94a.5.5 0 1 1-.708.707L8 8l-1.939 1.94a.5.5 0 1 1-.707-.708L7.293 7.293 5.354 5.354z" />
    </svg>
  ),
  Excel: (p) => (
    <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M5 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6.5A1.5 1.5 0 0 0 13 13.5V5l-4-4H5z" />
      <path d="M9 1.5V5h3.5L9 1.5z" />
      <path d="M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 7.293 5.354 5.354z" />
    </svg>
  ),
  PlusLg: (p) => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2z" />
    </svg>
  ),
  Copy: (p) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" {...p}>
      <path d="M16 1H4a2 2 0 0 0-2 2v12h2V3h12V1z" />
      <path d="M19 5H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H8V7h11v14z" />
    </svg>
  ),
};

/* ----------------------------- Utils & Formats ----------------------------- */
const toYMD = (d) => {
  if (!d) return "";
  const dt = typeof d === "string" ? new Date(d) : d;
  if (Number.isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const da = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
};
const toNum = (v) => {
  const s = String(v ?? "").replace(/,/g, "");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : 0;
};
const normalizeMoney = (v) => {
  const n = toNum(v);
  return Math.abs(n) < 0.005 ? 0 : Number(n.toFixed(2));
};
const fmt2 = (n) => toNum(n).toFixed(2);
const INR_NUMFMT_RED_NEG = '_-₹ * #,##0.00_ ;[Red]-₹ * #,##0.00_ ;_-₹ * "-"??_ ;_-@_ ';

/* --------------------------- AI-ish Visual Goodies -------------------------- */
const Sparkles = () => {
  const dots = React.useMemo(
    () =>
      Array.from({ length: 18 }).map((_, i) => ({
        id: i,
        left: `${Math.random() * 92 + 4}%`,
        top: `${Math.random() * 60 + 8}%`,
        size: Math.random() * 6 + 3,
        dur: Math.random() * 4 + 3,
        delay: Math.random() * 2,
      })),
    []
  );
  return (
    <div aria-hidden style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}>
      {dots.map((d) => (
        <motion.span
          key={d.id}
          initial={{ y: 16, opacity: 0 }}
          animate={{ y: [-8, 8, -8], opacity: [0.12, 0.3, 0.12] }}
          transition={{ duration: d.dur, repeat: Infinity, delay: d.delay, ease: "easeInOut" }}
          style={{
            position: "absolute",
            left: d.left,
            top: d.top,
            width: d.size,
            height: d.size,
            borderRadius: 999,
            background: "radial-gradient(circle at 30% 30%, rgba(255,255,255,.9), rgba(255,255,255,0) 60%)",
            filter: "blur(.6px)",
          }}
        />
      ))}
    </div>
  );
};

const Confetti = ({ show }) => {
  if (!show) return null;
  const pieces = Array.from({ length: 26 }).map((_, i) => ({
    id: i,
    x: (Math.random() - 0.5) * 260,
    y: (Math.random() - 0.5) * 80,
    r: Math.random() * 360,
    s: Math.random() * 8 + 4,
    d: Math.random() * 0.6 + 0.6,
  }));
  const colors = ["#60A5FA", "#34D399", "#F472B6", "#FBBF24", "#A78BFA"];
  return (
    <div style={{ position: "fixed", top: "14%", left: "50%", zIndex: 9999, pointerEvents: "none" }}>
      {pieces.map((p) => (
        <motion.div
          key={p.id}
          initial={{ x: 0, y: 0, rotate: 0, opacity: 1 }}
          animate={{ x: p.x, y: p.y + 180, rotate: p.r, opacity: [1, 1, 0] }}
          transition={{ duration: 1.25 * p.d, ease: "easeOut" }}
          style={{ width: p.s, height: p.s, borderRadius: 2, background: colors[p.id % colors.length] }}
        />
      ))}
    </div>
  );
};

const Toasty = ({ type = "info", text, onDone }) => {
  const palettes = {
    success: ["#10B981", "#34D399"],
    info: ["#3B82F6", "#60A5FA"],
    warn: ["#F59E0B", "#FBBF24"],
    error: ["#EF4444", "#F87171"],
  };
  const icons = { success: "✓", info: "ℹ", warn: "!", error: "✖" };
  const [a, b] = palettes[type] || palettes.info;

  return (
    <motion.div
      initial={{ y: -30, opacity: 0, scale: 0.98 }}
      animate={{ y: 0, opacity: 1, scale: 1 }}
      exit={{ y: -30, opacity: 0, scale: 0.98 }}
      transition={{ type: "spring", stiffness: 260, damping: 22 }}
      onAnimationComplete={() => setTimeout(onDone, 1400)}
      style={{ position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)", zIndex: 10000 }}
    >
      <div
        style={{
          padding: "10px 14px",
          borderRadius: 12,
          color: "white",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          gap: 10,
          boxShadow: "0 10px 30px rgba(0,0,0,.15)",
          background: `linear-gradient(90deg, ${a}, ${b})`,
        }}
      >
        <span
          style={{
            width: 26,
            height: 26,
            display: "grid",
            placeItems: "center",
            background: "rgba(255,255,255,.25)",
            borderRadius: 8,
            fontSize: 14,
          }}
        >
          {icons[type] || icons.info}
        </span>
        <span>{text}</span>
      </div>
    </motion.div>
  );
};

/* --------------------------------- Component -------------------------------- */
const All_Customers = () => {
  const colRef = collection(db, "boost-acc");

  // base
  const [records, setRecords] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ mobileNumber: "", name: "", amount: "" });
  const [errors, setErrors] = useState({});
  const [editId, setEditId] = useState(null);
  const [confirmDel, setConfirmDel] = useState({ show: false, id: null, name: "" });

  // main search
  const [mainSearch, setMainSearch] = useState("");

  // NEW: amount filter (+ve / -ve / 0 / all)
  const [amountFilter, setAmountFilter] = useState("all");

  // full-screen editor
  const [showFull, setShowFull] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowSearch, setRowSearch] = useState("");
  const [modalFromDate, setModalFromDate] = useState("");
  const [modalToDate, setModalToDate] = useState("");

  // AI goodies
  const [confetti, setConfetti] = useState(false);
  const [toast, setToast] = useState(null);
  const [glowId, setGlowId] = useState(null);

  const byId = (id) => records.find((r) => r.id === id);

  useEffect(() => {
    (async () => {
      const snap = await getDocs(colRef);
      setRecords(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    })();
  }, []);

  // helpers
  const validateForm = () => {
    const e = {};
    if (!/^\d{10}$/.test(form.mobileNumber || "")) e.mobileNumber = "Enter 10-digit mobile";
    if (!String(form.name || "").trim()) e.name = "Name is required";
    if (form.amount === "" || isNaN(toNum(form.amount))) e.amount = "Amount must be a number";
    setErrors(e);
    return !Object.keys(e).length;
  };

  const openAdd = () => {
    setShowForm(true);
    setForm({ mobileNumber: "", name: "", amount: "" });
    setErrors({});
    setEditId(null);
    setToast({ type: "info", text: "Add new record" });
  };

  const onFormChange = (e) => {
    const { name, value } = e.target;
    setForm((p) =>
      name === "mobileNumber"
        ? { ...p, [name]: value.replace(/\D/g, "").slice(0, 10) }
        : { ...p, [name]: value }
    );
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setToast({ type: "warn", text: "Fix validation errors" });
      return;
    }

    const payload = {
      mobileNumber: form.mobileNumber.trim(),
      name: form.name.trim(),
      amount: toNum(form.amount),
    };

    if (editId) {
      await updateDoc(doc(db, "boost-acc", editId), payload);
      setRecords((p) => p.map((r) => (r.id === editId ? { ...r, ...payload } : r)));
      setGlowId(editId);
      setToast({ type: "success", text: "Record updated" });
    } else {
      const d = await addDoc(colRef, payload);
      const id = d.id;
      setRecords((p) => [...p, { id, ...payload }]);
      setGlowId(id);
      setToast({ type: "success", text: "Record added" });
    }

    setConfetti(true);
    setTimeout(() => setConfetti(false), 900);
    setShowForm(false);
  };

  const promptDelete = (id, name) => {
    setConfirmDel({ show: true, id, name });
  };

  const confirmDeleteFn = async () => {
    const { id } = confirmDel;
    if (!id) return;
    await deleteDoc(doc(db, "boost-acc", id));
    setRecords((p) => p.filter((r) => r.id !== id));
    setConfirmDel({ show: false, id: null, name: "" });
    setToast({ type: "error", text: "Record deleted" });
  };

  // FULL editor
  const openFullEdit = (record) => {
    setEditId(record.id);
    const src = Array.isArray(record.transactions) ? record.transactions : [];
    const initial =
      src.length > 0
        ? src
        : [
            {
              id: `${Date.now()}-0`,
              holderName: record.name || "",
              cardLast4: "",
              swipeType: "Swipe",
              details: "",
              txnAmount: String(record.amount ?? "0"),
              adjAmount: "",
              txnDate: toYMD(new Date()),
            },
          ];

    setRows(
      initial.map((r, i) => ({
        id: r.id || `${Date.now()}-${i}`,
        holderName: r.holderName ?? record.name ?? "",
        cardLast4: String(r.cardLast4 ?? "").slice(-4),
        swipeType: r.swipeType === "Pay" ? "Pay" : "Swipe",
        details: r.details ?? "",
        txnAmount: String(typeof r.txnAmount === "string" ? r.txnAmount : r.txnAmount ?? 0),
        adjAmount: String(typeof r.adjAmount === "string" ? r.adjAmount : r.adjAmount ?? ""),
        txnDate: r.txnDate ? toYMD(r.txnDate) : toYMD(new Date()),
      }))
    );

    setRowSearch("");
    setModalFromDate("");
    setModalToDate("");
    setShowFull(true);
    setToast({ type: "info", text: "Editing transactions" });
  };

  /* -------- rowChange with % support for Extra/Reduce Charges ---------- */
  const rowChange = (id, key, val) =>
    setRows((prev) =>
      prev.map((r) => {
        if (r.id !== id) return r;

        // Card last 4 digits
        if (key === "cardLast4") {
          return {
            ...r,
            cardLast4: String(val || "").replace(/\D/g, "").slice(-4),
          };
        }

        // Date
        if (key === "txnDate") {
          return {
            ...r,
            txnDate: toYMD(val),
          };
        }

        // Transaction Amount – just store raw string; we convert with toNum later
        if (key === "txnAmount") {
          return {
            ...r,
            txnAmount: String(val ?? ""),
          };
        }

        // Extra / Reduce Charges – accepts amount or percentage like "2%" / "-2.5%"
        if (key === "adjAmount") {
          const raw = String(val ?? "").trim();
          if (!raw) {
            return { ...r, adjAmount: "" };
          }

          if (raw.endsWith("%")) {
            const pct = parseFloat(raw.slice(0, -1)); // drop '%'
            if (Number.isFinite(pct)) {
              const base = toNum(r.txnAmount); // Transaction Amount
              const amt = (base * pct) / 100;
              return {
                ...r,
                adjAmount: amt.toFixed(2), // store final amount
              };
            }
            // invalid % -> clear
            return { ...r, adjAmount: "" };
          }

          // plain amount
          return {
            ...r,
            adjAmount: raw,
          };
        }

        // default
        return {
          ...r,
          [key]: val,
        };
      })
    );

  const addRow = () =>
    setRows((p) => [
      ...p,
      {
        id: `${Date.now()}-${Math.random()}`,
        holderName: byId(editId)?.name || "",
        cardLast4: "",
        swipeType: "Swipe",
        details: "",
        txnAmount: "",
        adjAmount: "",
        txnDate: toYMD(new Date()),
      },
    ]);

  const removeRow = (id) => setRows((p) => p.filter((r) => r.id !== id));

  const grandTotal = useMemo(
    () => rows.reduce((s, r) => s + toNum(r.txnAmount) + toNum(r.adjAmount), 0),
    [rows]
  );

  const saveFull = async () => {
    if (!editId) return;
    const cleaned = rows.map((r) => ({
      id: r.id,
      holderName: (r.holderName || "").trim(),
      cardLast4: (r.cardLast4 || "").toString().slice(-4),
      swipeType: r.swipeType,
      details: r.details || "",
      txnAmount: toNum(r.txnAmount),
      adjAmount: toNum(r.adjAmount),
      total: toNum(r.txnAmount) + toNum(r.adjAmount),
      txnDate: r.txnDate || toYMD(new Date()),
    }));

    await updateDoc(doc(db, "boost-acc", editId), {
      amount: toNum(grandTotal),
      transactions: cleaned,
    });

    setRecords((p) =>
      p.map((r) => (r.id === editId ? { ...r, amount: toNum(grandTotal), transactions: cleaned } : r))
    );
    setShowFull(false);
    setEditId(null);
    setRows([]);
    setToast({ type: "success", text: "Transactions saved" });
    setConfetti(true);
    setTimeout(() => setConfetti(false), 900);
  };

  // modal filters
  const modalFilteredRows = useMemo(() => {
    const q = rowSearch.trim().toLowerCase();
    const from = modalFromDate ? new Date(modalFromDate) : null;
    const to = modalToDate ? new Date(modalToDate) : null;
    if (to) to.setHours(23, 59, 59, 999);

    return rows.filter((t) => {
      const textOK = q
        ? [
            t.holderName,
            t.cardLast4,
            t.swipeType,
            t.details,
            t.txnAmount,
            t.adjAmount,
            toNum(t.txnAmount) + toNum(t.adjAmount),
            t.txnDate,
          ]
            .map((v) => String(v ?? "").toLowerCase())
            .some((s) => s.includes(q))
        : true;

      const dateOK =
        from || to
          ? (() => {
              const d = t?.txnDate ? new Date(t.txnDate) : null;
              if (!d || Number.isNaN(d.getTime())) return false;
              if (from && d < from) return false;
              if (to && d > to) return false;
              return true;
            })()
          : true;

      return textOK && dateOK;
    });
  }, [rows, rowSearch, modalFromDate, modalToDate]);

  const modalComputedRows = useMemo(() => {
    let running = 0;
    return modalFilteredRows.map((t) => {
      const total = normalizeMoney(toNum(t.txnAmount) + toNum(t.adjAmount));
      const openBal = normalizeMoney(running);
      running = normalizeMoney(running + total);
      return { ...t, __total: total, __open: openBal };
    });
  }, [modalFilteredRows]);

  // main page filtering (search + amount filter)
  const filteredRecords = useMemo(() => {
    const q = mainSearch.trim().toLowerCase();

    return records.filter((r) => {
      const amount = toNum(r.amount);

      const matchesText = q
        ? [r.mobileNumber, r.name, fmt2(r.amount)]
            .map((v) => String(v ?? "").toLowerCase())
            .some((s) => s.includes(q))
        : true;

      let matchesAmount = true;
      if (amountFilter === "positive") {
        matchesAmount = amount > 0;
      } else if (amountFilter === "negative") {
        matchesAmount = amount < 0;
      } else if (amountFilter === "zero") {
        matchesAmount = amount === 0;
      }

      return matchesText && matchesAmount;
    });
  }, [records, mainSearch, amountFilter]);

  const mainTotal = useMemo(
    () => filteredRecords.reduce((s, r) => s + toNum(r.amount), 0),
    [filteredRecords]
  );

  // export (main summary only)
  const exportMainToExcel = async () => {
    const XLSX = await import("xlsx");
    const header = ["S.No", "Mobile Number", "Name", "Amount"];
    const body = filteredRecords.map((r, i) => [i + 1, r.mobileNumber, r.name, toNum(r.amount)]);
    const aoa = [header, ...body, [], ["", "", "Total", toNum(mainTotal)]];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = [{ wch: 6 }, { wch: 14 }, { wch: 24 }, { wch: 14 }];
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = 1; R <= range.e.r; R++) {
      const addr = XLSX.utils.encode_cell({ r: R, c: 3 });
      if (ws[addr]) ws[addr].z = INR_NUMFMT_RED_NEG;
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Accounts");
    XLSX.writeFile(wb, `${toYMD(new Date())}.xlsx`);
    setToast({ type: "info", text: "Exported to Excel" });
  };

  // export (modal rows only)
  const exportModalRowsToExcel = async () => {
    const XLSX = await import("xlsx");
    const header = [
      "S.No",
      "Date",
      "Card Holder Name",
      "Card Last 4",
      "Swipe/Pay",
      "Transaction Details",
      "Transaction Amount",
      "Extra/Reduce Charges",
      "Opening Balance",
      "Total Amount",
    ];

    const rowsData = modalComputedRows.map((t, i) => [
      i + 1,
      toYMD(t.txnDate),
      t.holderName,
      t.cardLast4,
      t.swipeType,
      t.details,
      toNum(t.txnAmount),
      toNum(t.adjAmount),
      toNum(t.__open),
      toNum(t.__total),
    ]);

    const aoa = [
      header,
      ...rowsData,
      [],
      ["", "", "", "", "", "", "", "Grand Total", "", toNum(grandTotal)],
    ];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = [
      { wch: 6 },
      { wch: 12 },
      { wch: 22 },
      { wch: 12 },
      { wch: 10 },
      { wch: 28 },
      { wch: 18 },
      { wch: 20 },
      { wch: 18 },
      { wch: 16 },
    ];
    const ref = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = 1; R <= ref.e.r; R++) {
      [6, 7, 8, 9].forEach((C) => {
        const addr = XLSX.utils.encode_cell({ r: R, c: C });
        if (ws[addr]) ws[addr].z = INR_NUMFMT_RED_NEG;
      });
    }
    const totalCell = XLSX.utils.encode_cell({ r: rowsData.length + 2, c: 9 });
    if (ws[totalCell]) ws[totalCell].z = INR_NUMFMT_RED_NEG;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Transactions");
    XLSX.writeFile(wb, `transactions_${toYMD(new Date())}.xlsx`);
    setToast({ type: "info", text: "Transactions exported" });
  };

  // export (all-in-one workbook): summary + each customer's transactions
  const exportAllCustomersWorkbook = async () => {
    const XLSX = await import("xlsx");

    // --- Sheet 1: All Customers summary ---
    const summaryHeader = ["S.No", "Mobile Number", "Name", "Amount"];
    const summaryBody = records.map((r, i) => [i + 1, r.mobileNumber, r.name, toNum(r.amount)]);
    const summaryAoa = [
      summaryHeader,
      ...summaryBody,
      [],
      ["", "", "Total", records.reduce((s, r) => s + toNum(r.amount), 0)],
    ];
    const wsSummary = XLSX.utils.aoa_to_sheet(summaryAoa);
    wsSummary["!cols"] = [{ wch: 6 }, { wch: 14 }, { wch: 24 }, { wch: 14 }];

    if (wsSummary["!ref"]) {
      const ref = XLSX.utils.decode_range(wsSummary["!ref"]);
      for (let R = 1; R <= ref.e.r; R++) {
        const addr = XLSX.utils.encode_cell({ r: R, c: 3 });
        if (wsSummary[addr]) wsSummary[addr].z = INR_NUMFMT_RED_NEG;
      }
    }

    // Create workbook and append summary
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsSummary, "All Customers");

    // --- Per-customer transaction sheets ---
    const txnHeader = [
      "S.No",
      "Date",
      "Card Holder Name",
      "Card Last 4",
      "Swipe/Pay",
      "Transaction Details",
      "Transaction Amount",
      "Extra/Reduce Charges",
      "Opening Balance",
      "Total Amount",
    ];

    const safeSheetName = (raw, fallback) => {
      const s = String(raw || fallback || "Sheet")
        .replace(/[\\/?*\[\]:]/g, "")
        .trim() || "Sheet";
      return s.length > 31 ? s.slice(0, 31) : s;
    };

    records.forEach((rec, idx) => {
      const namePart = rec.name ? rec.name.trim() : `C${idx + 1}`;
      const mobTail = String(rec.mobileNumber || "").slice(-4);
      const sheetName = safeSheetName(`${namePart}_${mobTail}`, `C${idx + 1}`);

      const txns =
        Array.isArray(rec.transactions) && rec.transactions.length
          ? rec.transactions
          : [
              {
                id: `${Date.now()}-${idx}`,
                holderName: rec.name || "",
                cardLast4: "",
                swipeType: "Swipe",
                details: "(derived from current amount)",
                txnAmount: toNum(rec.amount),
                adjAmount: 0,
                txnDate: toYMD(new Date()),
              },
            ];

      let running = 0;
      const rowsData = txns.map((t, i) => {
        const txnAmount = toNum(t.txnAmount);
        const adjAmount = toNum(t.adjAmount);
        const open = normalizeMoney(running);
        const total = normalizeMoney(txnAmount + adjAmount);
        running = normalizeMoney(running + total);

        return [
          i + 1,
          toYMD(t.txnDate),
          t.holderName || rec.name || "",
          String(t.cardLast4 || "").slice(-4),
          t.swipeType === "Pay" ? "Pay" : "Swipe",
          t.details || "",
          txnAmount,
          adjAmount,
          open,
          total,
        ];
      });

      const grand = rowsData.reduce((s, r) => s + toNum(r[9]), 0);

      const aoa = [txnHeader, ...rowsData, [], ["", "", "", "", "", "", "", "Grand Total", "", grand]];

      const ws = XLSX.utils.aoa_to_sheet(aoa);
      ws["!cols"] = [
        { wch: 6 },
        { wch: 12 },
        { wch: 22 },
        { wch: 12 },
        { wch: 10 },
        { wch: 28 },
        { wch: 18 },
        { wch: 20 },
        { wch: 18 },
        { wch: 16 },
      ];

      if (ws["!ref"]) {
        const ref = XLSX.utils.decode_range(ws["!ref"]);
        for (let R = 1; R <= ref.e.r; R++) {
          [6, 7, 8, 9].forEach((C) => {
            const addr = XLSX.utils.encode_cell({ r: R, c: C });
            if (ws[addr]) ws[addr].z = INR_NUMFMT_RED_NEG;
          });
        }
        const totalCell = XLSX.utils.encode_cell({ r: rowsData.length + 2, c: 9 });
        if (ws[totalCell]) ws[totalCell].z = INR_NUMFMT_RED_NEG;
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    XLSX.writeFile(wb, `${toYMD(new Date())}.xlsx`);
    setToast({
      type: "info",
      text: "Workbook exported: All + per-customer",
    });
  };

  const buildPaymentNote = (amountNumber) => {
    const amt = fmt2(amountNumber);
    return `Amount: ${amt}
Name:- Pavuluri Yogeswararao
Upi :- ccpay.99122559002003@icici
please send screenshot once payment done`;
  };

  const copyPaymentNote = async (record) => {
    const text = buildPaymentNote(record.amount);
    await navigator.clipboard.writeText(text);
    setToast({ type: "info", text: "Payment note copied" });
    setConfetti(true);
    setGlowId(record.id);
    setTimeout(() => setConfetti(false), 700);
    setTimeout(() => setGlowId(null), 900);
  };

  const anyModalOpen = showForm || showFull || confirmDel.show;

  return (
    <div className="all-customers-wrapper" style={{ position: "relative" }}>
      <Sparkles />
      <Confetti show={confetti} />
      <AnimatePresence>
        {toast && <Toasty key={toast.text} {...toast} onDone={() => setToast(null)} />}
      </AnimatePresence>

      {/* Header */}
      <motion.h2
        initial={{ backgroundPositionX: "0%" }}
        animate={{ backgroundPositionX: ["0%", "100%", "0%"] }}
        transition={{ duration: 6, repeat: Infinity, ease: "linear" }}
        style={{
          backgroundImage: "linear-gradient(90deg,#22d3ee,#a78bfa,#f472b6,#fbbf24,#22d3ee)",
          backgroundSize: "200% 100%",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
          fontWeight: 900,
          letterSpacing: ".5px",
          marginBottom: 12,
        }}
      >
        All Customers
      </motion.h2>

      {/* Command Bar */}
      <motion.div
        className={`d-flex flex-wrap gap-2 mb-3 ${anyModalOpen ? "page-dim" : ""}`}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          background: "linear-gradient(90deg, rgba(59,130,246,.08), rgba(236,72,153,.08))",
          padding: 12,
          borderRadius: 12,
          border: "1px solid rgba(99,102,241,.15)",
          boxShadow: "0 8px 28px -16px rgba(99,102,241,.25)",
        }}
      >
        <motion.button
          whileHover={{ scale: 1.03, y: -1 }}
          whileTap={{ scale: 0.98 }}
          className="ai-btn icon-btn"
          onClick={openAdd}
          title="Add new record"
        >
          <Icon.Plus />
          Add
        </motion.button>

        <div className="ms-auto d-flex gap-2 align-items-center">
          <div className="position-relative">
            <input
              className="form-control"
              style={{
                minWidth: 260,
                paddingLeft: 40,
                height: 42,
                borderRadius: 12,
                border: "1px solid rgba(99,102,241,.25)",
              }}
              placeholder="Search name / mobile / amount"
              value={mainSearch}
              onChange={(e) => setMainSearch(e.target.value)}
            />
            <span
              style={{
                position: "absolute",
                left: 12,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              🔎
            </span>
          </div>

          {/* Amount filter: +ve / -ve / 0 */}
          <select
            className="form-select"
            style={{ width: 160, height: 42, borderRadius: 12 }}
            value={amountFilter}
            onChange={(e) => setAmountFilter(e.target.value)}
          >
            <option value="all">All amounts</option>
            <option value="positive">Positive (+)</option>
            <option value="negative">Negative (-)</option>
            <option value="zero">Zero (0)</option>
          </select>

          {/* Summary-only export */}
          <motion.button
            whileHover={{ scale: 1.03, y: -1 }}
            whileTap={{ scale: 0.98 }}
            className="btn btn-outline-success icon-btn"
            onClick={exportMainToExcel}
            title="Export Summary"
            style={{ borderRadius: 12 }}
          >
            <Icon.Download />
            Export
          </motion.button>

          {/* New: full workbook export */}
          <motion.button
            whileHover={{ scale: 1.03, y: -1 }}
            whileTap={{ scale: 0.98 }}
            className="btn btn-outline-primary icon-btn"
            onClick={exportAllCustomersWorkbook}
            title="Export All (Summary + Individual Sheets)"
            style={{ borderRadius: 12 }}
          >
            <Icon.Excel />
            Export All (Sheets)
          </motion.button>
        </div>
      </motion.div>

      {/* Summary chip */}
      <div className={`${anyModalOpen ? "page-dim" : ""} d-flex justify-content-end mb-2`}>
        <motion.div
          initial={{ scale: 0.98, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 240, damping: 18 }}
          className={`px-3 py-2 rounded fw-bold ${
            toNum(
              filteredRecords.reduce((s, r) => s + toNum(r.amount), 0)
            ) < 0
              ? "bg-neg-chip"
              : "bg-pos-chip"
          }`}
        >
          ₹{" "}
          {fmt2(
            filteredRecords.reduce((s, r) => s + toNum(r.amount), 0)
          )}
        </motion.div>
      </div>

      {/* Main Table */}
      <div
        className={`${anyModalOpen ? "page-dim" : ""} table-container mt-3`}
        style={{ overflowX: "auto" }}
      >
        <table className="table table-striped custom-table theme-soft">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Mobile Number</th>
              <th>Name</th>
              <th>Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <AnimatePresence>
              {filteredRecords.length ? (
                filteredRecords.map((r, i) => {
                  const neg = toNum(r.amount) < 0;
                  const glow = glowId === r.id;
                  return (
                    <motion.tr
                      key={r.id}
                      initial={{ opacity: 0, y: 8 }}
                      animate={{
                        opacity: 1,
                        y: 0,
                        backgroundColor: glow ? "rgba(16,185,129,.08)" : "transparent",
                      }}
                      exit={{
                        opacity: 0,
                        y: -8,
                        backgroundColor: "rgba(239,68,68,.08)",
                      }}
                      transition={{ duration: 0.22 }}
                      className={neg ? "row-neg" : "row-pos"}
                      onAnimationComplete={() => glow && setTimeout(() => setGlowId(null), 900)}
                      style={{ position: "relative" }}
                    >
                      {glow && (
                        <motion.div
                          initial={{ opacity: 0, scale: 0.98 }}
                          animate={{
                            opacity: [0.7, 0],
                            scale: [1, 1.05],
                          }}
                          transition={{ duration: 0.9 }}
                          style={{
                            position: "absolute",
                            inset: 0,
                            borderRadius: 10,
                            border: "2px solid rgba(16,185,129,.45)",
                            pointerEvents: "none",
                          }}
                        />
                      )}
                      <td>{i + 1}</td>
                      <td>{r.mobileNumber}</td>
                      <td>{r.name}</td>
                      <td className="fw-semibold">₹ {fmt2(r.amount)}</td>
                      <td className="d-flex gap-1">
                        {/* Copy payment note */}
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.97 }}
                          className="btn btn-info btn-square-sm"
                          onClick={() => copyPaymentNote(r)}
                          title="Copy payment note"
                        >
                          <Icon.Copy />
                        </motion.button>

                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.97 }}
                          className="btn btn-warning btn-square-sm"
                          onClick={() => openFullEdit(r)}
                          title="Edit"
                        >
                          <Icon.Pencil />
                        </motion.button>

                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.97 }}
                          className="btn btn-danger btn-square-sm"
                          onClick={() => promptDelete(r.id, r.name)}
                          title="Delete"
                        >
                          <Icon.Trash />
                        </motion.button>
                      </td>
                    </motion.tr>
                  );
                })
              ) : (
                <motion.tr initial={{ opacity: 0 }} animate={{ opacity: 0.9 }}>
                  <td colSpan={5} className="text-center text-muted">
                    No records match your search.
                  </td>
                </motion.tr>
              )}
            </AnimatePresence>
          </tbody>
        </table>
      </div>

      {/* ----------------- MODALS ----------------- */}
      {/* Small Add/Edit */}
      <AnimatePresence>
        {showForm && (
          <>
            <motion.div
              className="backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />
            <motion.div
              className="modal show d-block"
              tabIndex="-1"
              style={{ zIndex: 1051 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <div className="modal-dialog">
                <motion.div
                  className="modal-content"
                  initial={{ scale: 0.95, y: 8, opacity: 0 }}
                  animate={{ scale: 1, y: 0, opacity: 1 }}
                  exit={{ scale: 0.97, y: 8, opacity: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 240,
                    damping: 20,
                  }}
                  style={{
                    borderRadius: 16,
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="modal-header"
                    style={{
                      background:
                        "linear-gradient(90deg, rgba(59,130,246,.08), rgba(236,72,153,.08))",
                    }}
                  >
                    <h5 className="modal-title">
                      {editId ? "Edit Record" : "Add Record"}
                    </h5>
                    <button
                      className="btn btn-light btn-square-xs"
                      title="Close"
                      onClick={() => {
                        setShowForm(false);
                        setToast({
                          type: "info",
                          text: "Form closed",
                        });
                      }}
                    >
                      <Icon.X />
                    </button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={submitForm}>
                      <div className="mb-2">
                        <label className="form-label">Mobile Number</label>
                        <input
                          name="mobileNumber"
                          className={`form-control ${
                            errors.mobileNumber ? "is-invalid" : ""
                          }`}
                          value={form.mobileNumber}
                          onChange={onFormChange}
                        />
                        {errors.mobileNumber && (
                          <div className="invalid-feedback">
                            {errors.mobileNumber}
                          </div>
                        )}
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Name</label>
                        <input
                          name="name"
                          className={`form-control ${
                            errors.name ? "is-invalid" : ""
                          }`}
                          value={form.name}
                          onChange={onFormChange}
                        />
                        {errors.name && (
                          <div className="invalid-feedback">
                            {errors.name}
                          </div>
                        )}
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Amount</label>
                        <input
                          name="amount"
                          type="text"
                          inputMode="decimal"
                          className={`form-control ${
                            errors.amount ? "is-invalid" : ""
                          }`}
                          value={form.amount}
                          onChange={onFormChange}
                          placeholder="e.g. -10, 99.50"
                        />
                        {errors.amount && (
                          <div className="invalid-feedback">
                            {errors.amount}
                          </div>
                        )}
                      </div>
                      <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        className="ai-btn w-100 mt-2 icon-btn"
                      >
                        <Icon.Save />
                        Save
                      </motion.button>
                    </form>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Delete Confirm */}
      <AnimatePresence>
        {confirmDel.show && (
          <>
            <motion.div
              className="backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />
            <motion.div
              className="modal show d-block"
              tabIndex="-1"
              style={{ zIndex: 1051 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <div className="modal-dialog modal-sm">
                <motion.div
                  className="modal-content"
                  initial={{ scale: 0.95, y: 8, opacity: 0 }}
                  animate={{ scale: 1, y: 0, opacity: 1 }}
                  exit={{ scale: 0.97, y: 8, opacity: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 22,
                  }}
                  style={{ borderRadius: 14 }}
                >
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Delete</h5>
                    <button
                      className="btn btn-light btn-square-xs"
                      onClick={() => {
                        setConfirmDel({
                          show: false,
                          id: null,
                          name: "",
                        });
                        setToast({
                          type: "info",
                          text: "Delete cancelled",
                        });
                      }}
                      title="Close"
                    >
                      <Icon.X />
                    </button>
                  </div>
                  <div className="modal-body">
                    Delete <strong>{confirmDel.name || "this record"}</strong>?
                    <div className="d-flex gap-2 mt-3">
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.97 }}
                        className="btn btn-danger w-50 icon-btn"
                        onClick={confirmDeleteFn}
                      >
                        <Icon.Trash />
                        Delete
                      </motion.button>
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.97 }}
                        className="btn btn-secondary w-50 icon-btn"
                        onClick={() => {
                          setConfirmDel({
                            show: false,
                            id: null,
                            name: "",
                          });
                          setToast({
                            type: "info",
                            text: "Delete cancelled",
                          });
                        }}
                      >
                        <Icon.X />
                        Cancel
                      </motion.button>
                    </div>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Full-screen Editor */}
      <AnimatePresence>
        {showFull && (
          <motion.div
            className="d-flex flex-column"
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 1052,
              overflow: "auto",
              background: "rgba(0,0,0,0.65)",
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div
              style={{
                background: "#fff",
                width: "100%",
                minHeight: "100%",
              }}
            >
              {/* Header */}
              <div className="p-3 border-bottom d-flex flex-wrap gap-2 justify-content-between align-items-center">
                <div className="d-flex gap-2 flex-wrap">
                  <div>
                    <label className="form-label small">Mobile</label>
                    <input
                      className="form-control"
                      value={byId(editId)?.mobileNumber || ""}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="form-label small">Name</label>
                    <input
                      className="form-control"
                      value={byId(editId)?.name || ""}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="form-label small">Grand Total</label>
                    <input className="form-control" value={fmt2(grandTotal)} readOnly />
                  </div>
                </div>

                <div className="d-flex gap-2 flex-wrap">
                  <input
                    className="form-control"
                    placeholder="Search rows: name/card4/details/date/amount"
                    value={rowSearch}
                    onChange={(e) => setRowSearch(e.target.value)}
                    style={{ minWidth: 280 }}
                  />
                  <input
                    type="date"
                    className="form-control"
                    value={modalFromDate}
                    onChange={(e) => setModalFromDate(e.target.value)}
                  />
                  <input
                    type="date"
                    className="form-control"
                    value={modalToDate}
                    onChange={(e) => setModalToDate(e.target.value)}
                  />
                  {(modalFromDate || modalToDate) && (
                    <button
                      className="btn btn-light icon-btn"
                      onClick={() => {
                        setModalFromDate("");
                        setModalToDate("");
                      }}
                      title="Clear date filters"
                    >
                      <Icon.XCircle />
                      <span className="visually-hidden">Clear Dates</span>
                    </button>
                  )}
                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.98 }}
                    className="btn btn-outline-success icon-btn"
                    onClick={exportModalRowsToExcel}
                    title="Export"
                  >
                    <Icon.Excel />
                    Export
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.98 }}
                    className="btn btn-secondary btn-square-sm"
                    onClick={() => setShowFull(false)}
                    title="Close"
                  >
                    <Icon.X />
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.98 }}
                    className="btn btn-primary btn-square-sm"
                    onClick={saveFull}
                    title="Save"
                  >
                    <Icon.Save />
                  </motion.button>
                </div>
              </div>

              {/* Table */}
              <div className="p-3" style={{ overflowX: "auto" }}>
                <table className="table table-bordered align-middle custom-table theme-soft">
                  <thead>
                    <tr>
                      <th style={{ width: 60 }}>S.No</th>
                      <th style={{ minWidth: 180 }}>Card Holder Name</th>
                      <th style={{ width: 120 }}>Card Last 4</th>
                      <th style={{ width: 130 }}>Swipe/Pay</th>
                      <th style={{ minWidth: 220 }}>Transaction Details</th>
                      <th style={{ width: 140 }}>Transaction Amount</th>
                      <th style={{ width: 170 }}>Extra/Reduce Charges</th>
                      <th style={{ width: 160 }}>Opening Balance</th>
                      <th style={{ width: 140 }}>Total Amount</th>
                      <th style={{ width: 160 }}>Date</th>
                      <th style={{ width: 90 }}></th>
                    </tr>
                  </thead>

                  <tbody>
                    {(() => {
                      let serial = 0;
                      let prevOpenWasZero = false;
                      const out = [];

                      const pushAllClear = (k) => {
                        out.push(
                          <tr key={`gap-${k}`} className="gap-row">
                            <td colSpan={11}></td>
                          </tr>
                        );
                        out.push(
                          <tr key={`sep-${k}`} className="sep-row">
                            <td colSpan={11}>ALL CLEAR</td>
                          </tr>
                        );
                        out.push(
                          <tr key={`rehead-${k}`} className="rehead-row">
                            <th style={{ width: 60 }}>S.No</th>
                            <th style={{ minWidth: 180 }}>Card Holder Name</th>
                            <th style={{ width: 120 }}>Card Last 4</th>
                            <th style={{ width: 130 }}>Swipe/Pay</th>
                            <th style={{ minWidth: 220 }}>Transaction Details</th>
                            <th style={{ width: 140 }}>Transaction Amount</th>
                            <th style={{ width: 170 }}>Extra/Reduce Charges</th>
                            <th style={{ width: 160 }}>Opening Balance</th>
                            <th style={{ width: 140 }}>Total Amount</th>
                            <th style={{ width: 160 }}>Date</th>
                            <th style={{ width: 90 }}></th>
                          </tr>
                        );
                      };

                      modalComputedRows.forEach((row) => {
                        const opening = toNum(row.__open);
                        const total = toNum(row.__total);

                        if (opening === 0 && serial > 0 && !prevOpenWasZero) {
                          pushAllClear(row.id);
                        }
                        prevOpenWasZero = opening === 0;

                        serial += 1;

                        out.push(
                          <motion.tr
                            key={row.id}
                            initial={{ opacity: 0, y: 6 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -6 }}
                            className={total < 0 ? "row-neg" : "row-pos"}
                            transition={{ duration: 0.18 }}
                          >
                            <td>{serial}</td>
                            <td>
                              <input
                                className="form-control"
                                value={row.holderName}
                                onChange={(e) =>
                                  rowChange(row.id, "holderName", e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                inputMode="numeric"
                                maxLength={4}
                                value={row.cardLast4}
                                onChange={(e) =>
                                  rowChange(row.id, "cardLast4", e.target.value)
                                }
                                placeholder="1234"
                              />
                            </td>
                            <td>
                              <select
                                className="form-select"
                                value={row.swipeType}
                                onChange={(e) =>
                                  rowChange(row.id, "swipeType", e.target.value)
                                }
                              >
                                <option>Swipe</option>
                                <option>Pay</option>
                              </select>
                            </td>
                            <td>
                              <input
                                className="form-control"
                                value={row.details}
                                onChange={(e) =>
                                  rowChange(row.id, "details", e.target.value)
                                }
                                placeholder="Details / notes"
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="text"
                                inputMode="decimal"
                                value={row.txnAmount}
                                onChange={(e) =>
                                  rowChange(row.id, "txnAmount", e.target.value)
                                }
                                placeholder="e.g. -10 or 99.5"
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="text"
                                inputMode="decimal"
                                value={row.adjAmount}
                                onChange={(e) =>
                                  rowChange(row.id, "adjAmount", e.target.value)
                                }
                                placeholder="e.g. -2.5, 5 or 2%"
                              />
                            </td>
                            <td>
                              <input
                                className="form-control fw-semibold"
                                value={fmt2(opening)}
                                readOnly
                              />
                            </td>
                            <td>
                              <input
                                className="form-control fw-semibold"
                                value={fmt2(total)}
                                readOnly
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="date"
                                value={row.txnDate}
                                onChange={(e) =>
                                  rowChange(row.id, "txnDate", e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.97 }}
                                className="btn btn-sm btn-danger btn-square-xs"
                                onClick={() => removeRow(row.id)}
                                title="Remove"
                              >
                                <Icon.Trash />
                              </motion.button>
                            </td>
                          </motion.tr>
                        );
                      });

                      return out;
                    })()}
                  </tbody>

                  <tfoot>
                    <tr>
                      <td colSpan={9} className="text-end fw-bold">
                        Grand Total
                      </td>
                      <td
                        colSpan={2}
                        className={`fw-bold fs-5 text-end ${
                          toNum(grandTotal) < 0 ? "row-neg" : "bg-pos"
                        }`}
                      >
                        ₹ {fmt2(grandTotal)}
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <div className="d-flex justify-content-between mt-2">
                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.98 }}
                    className="btn btn-outline-primary icon-btn"
                    onClick={addRow}
                    title="Add row"
                  >
                    <Icon.PlusLg />
                    Add Row
                  </motion.button>
                  <div className="d-flex gap-2">
                    <motion.button
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.98 }}
                      className="btn btn-secondary icon-btn"
                      onClick={() => setShowFull(false)}
                      title="Cancel"
                    >
                      <Icon.X />
                      Cancel
                    </motion.button>
                    <motion.button
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.98 }}
                      className="btn btn-success icon-btn"
                      onClick={saveFull}
                      title="Save & Close"
                    >
                      <Icon.Save />
                      Save & Close
                    </motion.button>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default All_Customers;
